// extracted by mini-css-extract-plugin
export var button = "styles-module--button--2c480";
export var ctaIcon = "styles-module--ctaIcon--3a63e";
export var link = "styles-module--link--dab40";
export var quaternary = "styles-module--quaternary--ef9ac";
export var secondary = "styles-module--secondary--8ae8f";
export var tertiary = "styles-module--tertiary--21e7b";
export var transparent = "styles-module--transparent--fb74f";